import { useMobileOrientation } from "react-device-detect";
import { useTranslation } from "react-i18next";

interface ComparisonBoxProps {
  artistMetric?: number;
  recommentation: number;
  big: boolean;
}

const ComparisonBox: React.FC<ComparisonBoxProps> = ({
  artistMetric,
  recommentation: recommendation,
  big,
}) => {
  const { t } = useTranslation("radar");
  const { isPortrait } = useMobileOrientation();

  return (
    <div
      className={`${big ? "big" : "small"} ${
        isPortrait ? "mobile" : ""
      } comparator`}
    >
      <span>
        <b className="min">{artistMetric?.toFixed(1)}</b>{" "}
        {t("pages.CareerDiagnose.currentStatus")}
      </span>
      <span className="divider" />
      <span>
        <b className="median">{recommendation?.toFixed(1)} </b>
        {t("pages.CareerDiagnose.recommendation")}
      </span>
    </div>
  );
};

export default ComparisonBox;
